/* Aurora — scrim cursor.

   While the pointer sits on the dimmed area outside an open drawer, the native cursor is
   replaced by a round × that follows it, so "click anywhere out here to close" is visible
   instead of guessed. The same element serves every drawer and popup in the theme: any
   scrim carrying `.aurora-scrim` gets it, so a new drawer inherits the behaviour by adding
   one class rather than by writing more JS.

   Notes:
   - Fine pointers only. On touch there is no hover state to draw, and hiding the cursor
     would be meaningless, so the whole module opts out and `cursor: none` never applies.
   - The CSS that hides the native cursor is gated on the `aurora-scrim-cursor-on` class
     this file puts on <html>. If the script fails to load, the cursor stays normal.
   - The element is pointer-events:none, so the click still lands on the scrim below it and
     each drawer's existing close handler does the closing. This file never closes anything.
*/
(function () {
  var FINE = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)');
  if (!FINE || !FINE.matches) return;

  var el = null;
  var frame = 0;
  var x = 0;
  var y = 0;

  function build() {
    if (el) return;
    el = document.createElement('div');
    el.className = 'aurora-scrim-cursor';
    el.setAttribute('aria-hidden', 'true');
    // same cross as snippets/aurora-close-button.liquid, so it inherits Appearance → Icons
    el.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" focusable="false">' +
      '<path d="M7 7 17 17M17 7 7 17" stroke="currentColor" stroke-width="var(--icon-stroke, 1.6)" stroke-linecap="round"/>' +
      '</svg>';
    document.body.appendChild(el);
  }

  function paint() {
    frame = 0;
    el.style.transform = 'translate3d(' + x + 'px, ' + y + 'px, 0) translate(-50%, -50%)';
  }

  function move(e) {
    x = e.clientX;
    y = e.clientY;
    if (!frame) frame = requestAnimationFrame(paint);
  }

  function show(e) {
    build();
    x = e.clientX;
    y = e.clientY;
    // paint the position BEFORE fading in, or the first frame flies in from 0,0
    paint();
    el.classList.add('is-visible');
  }

  function hide() {
    if (el) el.classList.remove('is-visible');
  }

  var FLAG = '__auroraScrimCursor';

  function bind(scrim) {
    if (scrim[FLAG]) return;
    scrim[FLAG] = true;
    scrim.addEventListener('mouseenter', show);
    scrim.addEventListener('mousemove', move);
    scrim.addEventListener('mouseleave', hide);
    // clicking the scrim closes the drawer; a scrim that is hidden mid-hover never fires
    // mouseleave, so the × would stay on screen. Same for Escape.
    scrim.addEventListener('click', hide);
  }

  function scan(scope) {
    (scope || document).querySelectorAll('.aurora-scrim').forEach(bind);
  }

  function start() {
    document.documentElement.classList.add('aurora-scrim-cursor-on');
    scan();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') hide();
  });
  // drawers rendered by a section (mobile menu, collection filters) reappear on editor edits
  document.addEventListener('shopify:section:load', function (e) {
    scan(e.target);
  });
})();
